var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import { mapActions } from "vuex";
import VueDialog from "../../../interface/IVueDialog";
var InitStoreDialog = (function (_super) {
    __extends(InitStoreDialog, _super);
    function InitStoreDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.depot = {
            organ_name: '',
            depot_name: '',
            depot_pinyin: '',
            depot_code: '',
            depot_contact: '',
            depot_phone: '',
            depot_address: '',
            sort: '',
            organ_id: '',
            depot_id: ''
        };
        _this.storeEditInfo = {};
        _this.init_store_auth = false;
        _this.store_split_rule_auth = false;
        _this.init_store_index = 0;
        _this.store_split_rule_auth_index = 0;
        return _this;
    }
    InitStoreDialog.prototype.created = function () {
        this.init_store_index = this.init_store_auth == true ? 1 : 0;
        this.store_split_rule_auth_index = this.init_store_index + 1;
    };
    InitStoreDialog.prototype.mounted = function () {
    };
    InitStoreDialog.prototype.close = function () {
        this.$closeDialog();
    };
    InitStoreDialog.prototype.toInitStore = function () {
        this.$emit('toInitStore:ok');
    };
    InitStoreDialog.prototype.toStoreSplitRule = function () {
        this.$emit('toStoreSplitRule:ok');
    };
    InitStoreDialog = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], InitStoreDialog);
    return InitStoreDialog;
}(VueDialog));
export default InitStoreDialog;
